/** First N page tabs stay pinned in the bottom bar; the rest live in More. */
export const INLINE_TAB_LIMIT = 3

export function splitPageTabs<T>(tabs: T[]): { main: T[]; more: T[] } {
  if (tabs.length <= INLINE_TAB_LIMIT) {
    return { main: tabs, more: [] }
  }
  return {
    main: tabs.slice(0, INLINE_TAB_LIMIT),
    more: tabs.slice(INLINE_TAB_LIMIT),
  }
}

export function isOverflowValue<T extends { value: string | number }>(
  more: T[],
  value: string | number,
): boolean {
  return more.some(tab => tab.value === value)
}
